import {
  SHIPPED_VIEW_ID,
  IN_TRANSIT_VIEW_ID,
  DELIVERED_VIEW_ID,
  DELIVERY_EXCEPTION_VIEW_ID,
  VOIDED_VIEW_ID,
  RETURNS_VIEW_ID,
} from '../components/shipping-grid/views/view-id-constants';
import {
  ALL_ORDERS_SEARCH_RESULT_ID,
  AWAITING_PAYMENT_ID,
  AWAITING_SHIPMENT_ID,
  CANCELLED_ID,
  ON_HOLD_ID,
  PENDING_FULFILLMENT_ID,
  PENDING_PICKUP_ID,
  REJECTED_FULFILLMENT_ID,
} from '../pages/orders-page/orders-page-view-constants';

export const ALL_SEARCH_RESULTS_ORDER_STATUS = 'ASR'; // ASR is a contrived order status for All search results.

const SALES_ORDER_STATES = {
  ASR: ALL_ORDERS_SEARCH_RESULT_ID,
  AwaitingPayment: AWAITING_PAYMENT_ID,
  OnHold: ON_HOLD_ID,
  AwaitingShipment: AWAITING_SHIPMENT_ID,
  PendingFulfillment: PENDING_FULFILLMENT_ID,
  RejectedFulfillment: REJECTED_FULFILLMENT_ID,
  PendingPickup: PENDING_PICKUP_ID,
  Shipped: SHIPPED_VIEW_ID,
  Cancelled: CANCELLED_ID,
  Unknown: 'unknown',
};

const SHIPMENT_STATES = {
  IPP: 'in-progress-packing-slip-printed',
  ILC: 'in-progress-label-created',
  PNC: 'planned',
  PLV: VOIDED_VIEW_ID,
  OHD: '',
  DFT: '',
  COM: SHIPPED_VIEW_ID,
  TDX: DELIVERY_EXCEPTION_VIEW_ID,
  RET: RETURNS_VIEW_ID,
  LPP: SHIPPED_VIEW_ID,
  TIT: IN_TRANSIT_VIEW_ID,
  TDL: DELIVERED_VIEW_ID,
};

export const getViewNameFromOrderStatus = (status) => {
  const viewName = SALES_ORDER_STATES[status];
  if (!viewName) {
    return 'unknown';
  }
  return viewName;
};

export const getOrderStatusFromViewName = (name) => {
  const status = Object.keys(SALES_ORDER_STATES).find((key) => SALES_ORDER_STATES[key] === name);
  if (!status) {
    return 'UNK';
  }
  return status;
};

export const getViewNameFromShipmentStatus = (status) => {
  const viewName = SHIPMENT_STATES[status];
  if (!viewName) {
    return 'unknown';
  }
  return viewName;
};
